import { useState, useEffect, useRef, useContext } from "react";

/**
 * Hook that will render a component as not visible if a user clicks outside of the said component on the screen.
 * The exclusion prop is for an id of an element on the page that can be clicked by a user, and would not close
 * the component in which this hook is used.
 **/

export default function useComponentVisible(initialIsVisible: boolean, exclusion?: string) {
  const [isComponentVisible, setIsComponentVisible] = useState(initialIsVisible);
  const ref = useRef(null);

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target) && !event.target.id.endsWith(exclusion)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref, isComponentVisible, setIsComponentVisible };
}
